import { AlertSanOccurences } from "../../types/FieldOccurences/AlertSanOccurences";
import { PaginationValues } from "../../types/General/PaginationValues";
import api from "../../utils/api";
import { OCCURENCE_ALERT_SAN_URL } from "../../utils/endpoints";

export async function getOccurrenceAlertSan(
  id?: string,
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(
      id ? `${OCCURENCE_ALERT_SAN_URL}/${id}` : `${OCCURENCE_ALERT_SAN_URL}`,
      {
        params: {
          ...filterValues,
          ...paginationValues,
        },
      },
    );

    const data: AlertSanOccurences[] = id
      ? response.data.name
      : response.data.result.map((option: AlertSanOccurences) => ({
          id: option.id,
          title: option.title,
          type: option.type,
          level: option.level,
          alertSeverity: option.alertSeverity,
          origin: option.origin,
          createdAt: option.createdAt,
          finishedAt: option.finishedAt ?? null,
          isActive: option.isActive,
          province: option.province ?? null,
          county: option.county ?? null,
          occurrences: option.occurrences,
          alertSan: option.alertSan,
          dataPeriod: option.dataPeriod,
          year: option.year,
        }));
    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
